import { Link } from 'react-router-dom';
import './SubInfo.scss';

const SubInfo = ({ username, publishedDate, hasMarginTop }) => {
  return (
    <div className={`SubInfo${hasMarginTop ? ' hasMarginTop' : ''}`}>
      <span>
        <b>
          <Link to={`/@${username}`}>{username}</Link>
        </b>
      </span>
      <span>{new Date(publishedDate).toLocaleDateString()}</span>
    </div>
  );
};

export default SubInfo;
